import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../lib/constants';
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(null);
  const [fullname, setFullname] = useState(null);
  const [lastlogin, setLastlogin] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [hospitalId, setHospitalId] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/auth/verify`, { withCredentials: true })
      .then(response => {
        if (response.data.status === 'authenticated') {
          setIsAuthenticated(true);
          setUserRole(response.data.role);
          setFullname(response.data.fullname);
          setLastlogin(response.data.lastlogin);
          setPermissions(response.data.permissions || []);
          setHospitalId(response.data.hospital_id);
        } else {
          setIsAuthenticated(false);
          setUserRole(null);
          setFullname(null);
          setLastlogin(null);
          setPermissions([]);
          setHospitalId(null);
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
        setUserRole(null);
        setFullname(null);
        setLastlogin(null);
        setPermissions([]);
        setHospitalId(null);
      })
      .finally(() => {
        setAuthChecked(true);
      });
  }, []);

  return (
    <AuthContext.Provider value={{
      userRole,
      fullname,
      lastlogin,
      permissions,
      hospitalId,
      isAuthenticated,
      authChecked,
      setUserRole,
      setFullname,
      setLastlogin,
      setPermissions,
      setHospitalId,
      setIsAuthenticated
    }}>
      {children}
    </AuthContext.Provider>
  );
};
